export class EmptyProductHttpHeaderError extends Error {}
